import { useState } from "react";
import { Card, CardBody, Collapse, Col } from "reactstrap";
import LocationCheckBox from "./LocationCheckBox";
import HeaderWithIcon from "../../Common/HeaderWithIcon";
import { AllLocations, LocationHeading } from "../../../../Constant";
import { Btn } from "../../../../AbstractElements";

const Location = () => {
  const [isOpen, setIsOpen] = useState(true);
  return (
    <Col xl="12">
      <Card>
        <HeaderWithIcon heading={LocationHeading} isOpen={isOpen} setIsOpen={setIsOpen} />
        <Collapse isOpen={isOpen}>
          <CardBody className="animate-chk">
            <LocationCheckBox />
          </CardBody>
          <Btn className="btn-block text-center w-100" color="primary">{AllLocations}</Btn>
        </Collapse>
      </Card>
    </Col>
  );
};

export default Location;
